import { AvailabilitySlot } from 'common/components/entities/Calendar/calendar-interface'
import { getStartEndDates } from 'common/components/entities/Calendar/utils'
import {
  getPreviewTimeSlots,
  getTimeSlots,
} from 'publisher/api/booking-calendar-api'
import {
  getBookingFieldValue,
  getPaidBookingFieldValue,
} from 'publisher/reducers/optInReducer'
import { useOptIn } from 'publisher/store'
import { useEffect, useState } from 'react'
import { GetTimeSlotsArgs } from '../api/booking-calendar-api'

export const useEventTimeSlots = ({
  isPaidCalendar = false,
  isPreview = false,
}: {
  isPaidCalendar?: boolean
  isPreview?: boolean
}) => {
  const getBookingField = isPaidCalendar
    ? getPaidBookingFieldValue
    : getBookingFieldValue
  const eventId = useOptIn(optIn => getBookingField(optIn, 'eventId'))
  const ownerId = useOptIn(optIn => getBookingField(optIn, 'ownerId'))
  const startDate = useOptIn(optIn => getBookingField(optIn, 'startDate'))
  const endDate = useOptIn(optIn => getBookingField(optIn, 'endDate'))
  const isOptInSucceeded = useOptIn(optIn => optIn.success)
  const timeZone =
    useOptIn(optIn => getBookingField(optIn, 'timeZone')) ||
    Intl.DateTimeFormat().resolvedOptions().timeZone

  const [timeSlots, setTimeSlots] = useState<AvailabilitySlot[]>()
  const [error, setError] = useState<unknown>(null)
  const [isFetching, setIsFetching] = useState(false)

  const fetch = async (args: GetTimeSlotsArgs) => {
    try {
      setIsFetching(true)
      const getTimeSlotsFunc = isPreview ? getPreviewTimeSlots : getTimeSlots
      const res = await getTimeSlotsFunc(args)
      setTimeSlots(res.data)
    } catch (error) {
      setError(error)
    } finally {
      setIsFetching(false)
    }
  }

  useEffect(() => {
    if (eventId) {
      const timezone = timeZone
      const defaultMonth = getStartEndDates(new Date())
      fetch({
        eventId,
        startDate: startDate || defaultMonth.startDate,
        endDate: endDate || defaultMonth.endDate,
        timezone,
        ownerId,
      })
    }
  }, [eventId, timeZone, startDate, endDate, ownerId, isOptInSucceeded])

  return { timeSlots, isFetching, error, fetch }
}
